import { render } from "./StaffPage.vue?vue&type=template&id=1aac4c3a&scoped=true"
import script from "./StaffPage.vue?vue&type=script&lang=js"
export * from "./StaffPage.vue?vue&type=script&lang=js"

import "./StaffPage.vue?vue&type=style&index=0&id=1aac4c3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aac4c3a"]])

export default __exports__